module.exports = __webpack_public_path__ + "img/SMT_10_Mr_Soh_Keng_Taan.2cde0ce9.jpg";